import React from 'react';
import { Tabs, Tab, Grid, useTheme } from '@material-ui/core';

//reusable tabs component.
const CustomTabs = ({ tabs }) => {
	const [value, setCategoryTabIndex] = React.useState(0);
	//Tab panel
	const TabPanel = (panelProps) => {
		const { children, value, index, ...other } = panelProps;
		return (
			<Grid
				container
				item
				role="tabpanel"
				hidden={value !== index}
				id={`full-width-tabpanel-${index}`}
				aria-labelledby={`full-width-tab-${index}`}
				{...other}
			>
				{value === index && (
					<Grid container item>
						{children}
					</Grid>
				)}
			</Grid>
		);
	};
	// re usable props creation  Obj
	const assetTabProps = (index) => {
		return {
			id: `full-width-tab-${index}`,
			'aria-controls': `full-width-tabpanel-${index}`,
		};
	};
	//Tabs component, responsible for the Tabs layout and content.
	const RenderTabs = () => {
		const theme = useTheme();

		//Retrieving the selection option object on results view
		const handleChange = (event, newValue) => {
			setCategoryTabIndex(newValue);
		};
		//Tab label with badge and count of the rows in cerrosponding tab
		return (
			<Grid container item direction="column">
				<Grid item>
					<Tabs
						value={value}
						onChange={handleChange}
						indicatorColor="primary"
						color="secondary"
						aria-label="custom tabs"
					>
						{tabs.map((tab, i) => {
							return <Tab data-cy={'tab-' + i} label={tab.label} key={tab.label} {...assetTabProps(i)} />;
						})}
					</Tabs>
				</Grid>
				{tabs.map((tab, i) => {
					return (
						<TabPanel value={value} index={i} key={i} dir={theme.direction}>
							{tab.component}
						</TabPanel>
					);
				})}
			</Grid>
		);
	};
	return <RenderTabs />;
};
export default CustomTabs;
